import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-type-field',
  templateUrl: './service-type-field.component.html',
  styleUrls: ['./service-type-field.component.scss']
})
export class ServiceTypeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
